import { render, staticRenderFns } from "./smetki-pdf.vue?vue&type=template&id=65685727"
import script from "./smetki-pdf.vue?vue&type=script&lang=js"
export * from "./smetki-pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports